import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { AuthSelectors, SuperStore } from '@bilancio/root-store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class OnlyDepositGuard {
  // Route consentite per utenti con isOnlyDeposit = true
  private readonly allowedRoutes = [
    'user',
    'fasifascicolo',
    'depositoViaLibera',
    'depositoPhase',
    'elencofascicoli',
  ];

  constructor(
    private readonly store: SuperStore,
    private readonly router: Router,
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    return this.store.select(AuthSelectors.getIsViaLiberaDeposit).pipe(
      map(isViaLiberaDeposit => {
        const path = this.getRoutePath(route);
        const firstSegment = path.split('/')[0];

        // Se l'utente NON è ViaLiberaDeposit, può accedere a tutto
        if (!isViaLiberaDeposit) {
          return true;
        }

        // Se l'utente è ViaLiberaDeposit, controlla se la route è consentita
        const isAllowed = this.allowedRoutes.includes(firstSegment);

        if (isAllowed) {
          return true;
        }

        // Se non è consentita, redirect a elencofascicoli
        return this.router.createUrlTree(['/elencofascicoli']);
      }),
    );
  }

  canActivateChild(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    return this.canActivate(route);
  }

  private getRoutePath(route: ActivatedRouteSnapshot): string {
    // Costruisce il path completo dalla route
    const segments: string[] = [];
    let current: ActivatedRouteSnapshot | null = route;

    while (current) {
      if (current.url.length > 0) {
        segments.unshift(...current.url.map(segment => segment.path));
      }
      current = current.parent;
    }

    return segments.join('/');
  }
}
